import { makeStyles, createStyles } from '@mui/styles';
export const useStyles = makeStyles(() => {
  return createStyles({
    search: {
      margin: '0',
    },
  });
});
